<template>
  <el-dialog title="发货" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
    <div class="dialog_conwrap">
      <el-form ref="form" :rules="rules" :model="formdata" label-width="120px">
        <el-form-item label="物流公司:" prop="shipping_id">
          <el-select popper-class="custom-select" v-model="formdata.shipping_id" placeholder="请选择">
            <el-option
              v-for="(item,index) in shippingoptions"
              :key="index"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号:" prop="shipping_code">
          <el-input v-model.number="formdata.shipping_code" placeholder="请输入物流单号" class="w280"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" @click="save('form')">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import api from "@/api.js";
export default {
  name: "deliveryDialog",
  props: ["visible", "id"],
  watch: {
    visible() {
      this.dialogVisible = this.visible;
    }
  },
  data() {
    return {
      dialogVisible: this.visible,
      formdata: {
        shipping_id: "",
        shipping_code: ""
      },
      shippingoptions: [],
      rules: {
        shipping_id: [
          { required: true, message: "请选择物流公司", trigger: "change" }
        ],
        shipping_code: [
          { required: true, message: "请输入物流单号", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.queryshippinglist();
  },
  methods: {
    // 查询物流公司
    queryshippinglist() {
      let params = {};
      this.axios
        .post(api.order_shipping_list, params)
        .then(response => {
          if (response.data.code == 0) {
            this.shippingoptions = response.data.list || [];
          } else {
          }
        })
        .catch(() => {});
    },
    // 保存
    save(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.submitsave();
        } else {
          return false;
        }
      });
    },
    // 提交保存
    submitsave() {
      let params = {
        order_id: this.id,
        shipping_id: this.formdata.shipping_id,
        shipping_code: this.formdata.shipping_code
      };
      this.axios
        .post(api.order_delivery, params)
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "发货成功",
            });
            this.$emit("deliverysuccess");
            this.dialogVisible = false;
          } else {
          }
        })
        .catch(() => {});
    }
  }
};
</script>

